function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
/**
 * Style Isolation Utilities for Micro-Frontend Architecture
 *
 * These utilities help prevent CSS conflicts between the host application
 * and remote micro-frontend applications that use different CSS frameworks.
 */
/**
 * Marks host application styles to prevent them from being scoped
 */
export var markHostStyles = function markHostStyles() {
    var styles = document.querySelectorAll('style');
    var _iterator = _createForOfIteratorHelper(styles), _step;
    try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var style = _step.value;
            if (!style.dataset.remoteApp && !style.dataset.app) {
                style.dataset.app = 'host';
            }
        }
    }
    catch (err) {
        _iterator.e(err);
    }
    finally {
        _iterator.f();
    }
};
/**
 * Cleans up remote application styles when unmounting
 */
export var cleanupRemoteStyles = function cleanupRemoteStyles(appName) {
    var remoteStyles = document.querySelectorAll("style[data-remote-app=\"".concat(appName, "\"], link[data-remote-app=\"").concat(appName, "\"]"));
    var _iterator2 = _createForOfIteratorHelper(remoteStyles), _step2;
    try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var style = _step2.value;
            style.remove();
        }
    }
    catch (err) {
        _iterator2.e(err);
    }
    finally {
        _iterator2.f();
    }
};
/**
export const scopeCSS = (css: string, scopeSelector: string): string => {
    try {
        // Simple CSS scoping - adds scope prefix to all selectors
        // This is a basic implementation; for production, consider using a CSS parser
        const rules = css.split('}').filter(Boolean)

        return rules
            .map((rule) => {
                const [selector, ...declarationParts] = rule.split('{')
                if (!selector || declarationParts.length === 0) return rule

                const declarations = declarationParts.join('{')
                const selectors = selector.split(',').map((s) => s.trim())

                const scopedSelectors = selectors.map((sel) => {
                    // Don't scope @-rules
                    if (sel.startsWith('@')) return sel

                    // Handle :root, html, body specially
                    if (sel === ':root' || sel === 'html' || sel === 'body') {
                        return `${scopeSelector} ${sel}, ${scopeSelector}`
                    }

                    // Scope regular selectors
                    return `${scopeSelector} ${sel}`
                })

                return `${scopedSelectors.join(', ')} { ${declarations} }`
            })
            .join('\n')
    } catch (error) {
        console.error('Error scoping CSS:', error)
        return css
    }
}

/**
 * Creates a sandboxed environment for remote app styles
 */
export var createStyleSandbox = function createStyleSandbox(appName) {
    var sandbox = {
        injectedStyles: new Set(),
        /**
         * Inject scoped styles for the remote app
         */
        injectStyle: function injectStyle(css, scope) {
            var scopedCSS = scopeCSS(css, scope);
            var styleElement = document.createElement('style');
            styleElement.textContent = scopedCSS;
            styleElement.dataset.remoteApp = appName;
            styleElement.dataset.scoped = 'true';
            document.head.appendChild(styleElement);
            this.injectedStyles.add(styleElement);
            return styleElement;
        },
        /**
         * Clean up all injected styles
         */
        cleanup: function cleanup() {
            var _iterator3 = _createForOfIteratorHelper(this.injectedStyles), _step3;
            try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var style = _step3.value;
                    style.remove();
                }
            }
            catch (err) {
                _iterator3.e(err);
            }
            finally {
                _iterator3.f();
            }
            this.injectedStyles.clear();
        }
    };
    return sandbox;
};
/**
 * CSS Reset for remote apps to prevent inheritance of host styles
 */
export var getResetCSS = function getResetCSS(scopeSelector) {
    return "\n\t\t".concat(scopeSelector, " {\n\t\t\t/* Reset box model */\n\t\t\tall: initial;\n\t\t\tdisplay: block;\n\t\t\t\n\t\t\t/* Re-enable box-sizing */\n\t\t\t*, *::before, *::after {\n\t\t\t\tbox-sizing: border-box;\n\t\t\t}\n\t\t}\n\t\t\n\t\t").concat(scopeSelector, " * {\n\t\t\t/* Reset inherited styles */\n\t\t\tfont-family: inherit;\n\t\t\tline-height: inherit;\n\t\t}\n\t");
};
/**
 * Monitors and logs CSS conflicts between host and remote apps
 */
export var createCSSConflictMonitor = function createCSSConflictMonitor() {
    var conflicts = new Map();
    return {
        /**
         * Check for style conflicts between host and remote
         */
        checkConflicts: function checkConflicts(element, appName) {
            var computedStyle = globalThis.window.getComputedStyle(element);
            var hostStyles = element.dataset.app === 'host';
            var remoteStyles = element.dataset.remoteApp === appName;
            if (hostStyles && remoteStyles) {
                conflicts.set(element.className, {
                    host: computedStyle.cssText,
                    remote: computedStyle.cssText
                });
            }
            return conflicts;
        },
        /**
         * Get all detected conflicts
         */
        getConflicts: function getConflicts() {
            return Array.from(conflicts.entries());
        },
        /**
         * Clear conflict history
         */
        clearConflicts: function clearConflicts() {
            conflicts.clear();
        }
    };
};
/**
 * Configuration for style isolation strategy
 */
export var defaultStyleIsolationConfig = {
    enableScoping: true,
    enableMonitoring: false,
    enableReset: false,
    scopePrefix: 'data-remote-app'
};
